/**
 * Created by Ning Jiang on 6/8/2016.
 */
import {Oktoberfest} from "../../Oktoberfest";
import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {GameHelper} from "../../../core/utils/GameHelper";


export class OktoberfestCollectionWPController extends WinPresentationController {

    private _scatterPositions: number[] = [-1, -1, -1, -1, -1];
    private _tokenWonThisSpin: number;
    private _freespinsLeft: number;
    private _freespinsWon: number;
    private _multiWon: number;

    private _collectionTimeLine: TimelineLite;

    constructor() {
        super("OktoberfestCollectionWPController", false);
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = new TimelineLite();
        let delay: number = 0;
        tl.to(this, {duration: 0.1}); // Add this line because the Oktoberfest server didn't give scatterPositions and the empty tl doesn't continue the promise chain.
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            this.playAllWinAnimation(resolve);
        });
    }

    protected onGameDataParsed() {
        this._scatterPositions = Oktoberfest.model.parsedGameData.scatterPositions!;
        this._tokenWonThisSpin = Oktoberfest.model.parsedGameData.beerTokensCollectedThisSpin;
        this._freespinsLeft = Oktoberfest.model.parsedGameData.freespinsLeft;
        this._freespinsWon = Oktoberfest.model.parsedGameData.addedNumberOfFreespinsThisSpin;
        this._multiWon = Oktoberfest.model.parsedGameData.addedMultiplierThisSpin;
    }

    protected hasWin(): boolean {
        this.onGameDataParsed();
        return this._tokenWonThisSpin > 0;
    }

    protected playAllWinAnimation(resolve: () => void): TimelineLite {
        this._collectionTimeLine = new TimelineLite({paused: true, onComplete: () => resolve()});
        Oktoberfest.model.reels.forEach((reels: string[], reelIndex: number) => {
                reels.forEach((symName, symIndex) => {
                    if (symIndex <= 2) {
                        const symbol = Oktoberfest.reels[reelIndex].getSymbol(symIndex);
                        GameHelper.dimDownAllSymbols(symbol, "S");
                    }
                });
        });
        // Add meter animation to the timeLine. This will add the label "multiplier" and "freespinLeft" in the timeLine.
        Oktoberfest.scatterMeter.updateLevelAnimation({shouldAnimate: true, timeLine: this._collectionTimeLine});
        // Add multiplier animation to the timeLine.
        if (this._multiWon > 0) {
            this._collectionTimeLine.add(
                () => this.updateMultiWon(),
                "multiplier"
            );
        }

        // Add freespin left update animation.
        if (this._freespinsWon > 0) {
            this._collectionTimeLine.add(
                () => this.updateFreespinsLeft(),
                "freespinsLeft"
            );
            this._collectionTimeLine.add(
                () => this.updateBeerGlass(),
                "bierglass"
            );
        }

        this._collectionTimeLine.play(0);
        return  this._collectionTimeLine;
    }

    protected setAllAnimationsToEndState(isAborted: boolean) {
        if (this._collectionTimeLine && this._collectionTimeLine.isActive()) {
            this._collectionTimeLine.kill();
        }
        Oktoberfest.scatterMeter.updateLevelAnimation({shouldAnimate: false});
        Oktoberfest.fsMultiplier.updateLevelAnimation({shouldAnimate: false});
    }

    private updateMultiWon(): void {
        Oktoberfest.fsMultiplier.updateLevelAnimation({shouldAnimate: true});
    }

    private updateFreespinsLeft(): void {
        Oktoberfest.fsCollectionPresentationView.playAddFreespinsText(this._freespinsWon);
    }

    private updateBeerGlass(): void {
        Oktoberfest.leftIndicator.onFreespinsLeftUpdated(this._freespinsLeft);
    }
}